export default __webpack_public_path__ + "static/media/PR.STREAK.FOUR_WEEKS.c2f32afa.jpg";